import { Link } from "react-router-dom";
import { arrayMagazines } from "../../../data/arrayMagazines";

function MagazineGrid() {
  const displayMagazines = arrayMagazines.map((magazine) => {
    const slug = magazine.title.toLowerCase().replace(/\s+/g, "-");
    
    return (
      <div className="col-lg-3 col-md-4 col-sm-6 col-12" key={magazine.id}>
        <Link to={`/tidsskrift-kontakt/${slug}`} className="magazine-card">
          <div className="magazine-card-image">
            <img src={magazine.image} alt={magazine.title} className="img-fluid" />
          </div>
          <div className="magazine-card-content">
            <div className="magazine-card-title-price">
               <h3>{magazine.title}</h3>
            <p className="magazine-price">
              {magazine.price} NOK
            </p>
            </div>

           
            <div className="magazine-card-button">
              {magazine.comingSoon && !magazine.soldOut ? (
                <span className="coming-soon">Kommer snart</span>
              ) : magazine.soldOut ? (
                <span className="sold-out">Utsolgt</span>
              ) : (
                <span className="order-btn">Bestill</span>
              )}
            </div>
          </div>
        </Link>
      </div>
    );
  });

  return <div className="row magazine-grid">{displayMagazines}</div>;
}

export default MagazineGrid;